module.exports = __webpack_public_path__ + "images/emoji/haircut.7b7be3fd0a4b40cffd2d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/haircut.png
// module id = aOPf
// module chunks = 2